import FormComponent from '../../Form'
import { Stakeholders } from '../../Common'
import labels from '../../Common/translations'

export default {
   fields: {
      accessList: {
         label: labels.fields.access_list,
         type: FormComponent.SELECTMANY,
         mandatory: true,
         options: {
            defaultValue: [],
         },
         values: {
            from: 'state',
            prop: 'accessListValues',
            collection: 'roles',
            // get current user's stakeholders list,
            // for a partner it will include managed companies
            // for root, all companies
            source: props =>
               Stakeholders(
                  props.authUser.company.ref,
                  [],
                  props.data.accessList,
               ),
         },
      },
   },
   buttons: {
      submit: true,
      extras: [],
   },
   actions: {
      update: ({ uid, ...data }) => null,
   },
   extras: [],
}
